import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const DrawbackdetailsApi = createApi({
  reducerPath: "DrawbackdetailsApi",
  baseQuery,
  tagTypes: ["Drawbackdetails"],
  endpoints: (builder) => ({
///v1/customer/customer-notes/{CustomerId}/{CustomerNotesId}

    createDrawBack: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/customer/CustomDetailsDrawback/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) }, // /v1/customer/CustomDetailsDrawback/{CustomerId}/{CustomDetailsDrawbackId}
        body: { customDetailsDrawbackDetails: data },
      }),
      invalidatesTags: ["Drawbackdetails"],
    }),

    updateDrawBack: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/customer/CustomDetailsDrawback/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { customDetailsDrawbackDetails: data },
      }),
      invalidatesTags: ["Drawbackdetails"],
    }),


      
    getDrawBackByCustomHouseId: builder.query({
        query: ({ customerId, id }) => {
          console.log("➡️ API Request Params in draeback details:", { customerId, id });
          return `/customer/CustomDetailsDrawback/${customerId}/${id}`;
        },
      
        transformResponse: (response) => {
          console.log("⬅️ API Response:", response);
          return response?.data ?? null;
        },
      
        providesTags: ["Drawbackdetails"],
      }),
      
   
  
    deleteDrawBack: builder.mutation({
      query: ({ id }) => ({
        url: `/customer/CustomDetailsDrawback/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["Drawbackdetails"],
    }),

   
  })
});
export const {
    useCreateDrawBackMutation,
    useUpdateDrawBackMutation,
    useLazyGetDrawBackByCustomHouseIdQuery,
    useDeleteDrawBackMutation

  


 

} = DrawbackdetailsApi;


